export default __webpack_public_path__ + "static/networking_w.9589858d791f1fa344676e64f0ab22f9.svg";